import { render, staticRenderFns } from "./PopupBannerDetailPage.vue?vue&type=template&id=5bf9d73f"
import script from "./PopupBannerDetailPage.vue?vue&type=script&lang=js"
export * from "./PopupBannerDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports